import { GET_DRIVER_LIST, GET_ADDDRIVER, GET_UPDATEDRIVER, GET_TICKETDRIVER, GET_MATRIXDRIVER, GET_MOREDRIVER} from "resources/actionTypes";

export function getDriver(data) {
  return {
    type: GET_DRIVER_LIST.GET_DRIVER_LIST_REQUESTED,
    payload: data,
  };
}

export function postAddDriver(userAddDriver) {
  const data = {
    userAddDriver: userAddDriver,
  }
  return {
    type: GET_ADDDRIVER.GET_ADDDRIVER_REQUESTED,
    payload: data,
  };
}

export function patchUpdateDriver(userUpdateDriver) {
  const data = {
    userUpdateDriver: userUpdateDriver,
  }
  return {
    type: GET_UPDATEDRIVER.GET_UPDATEDRIVER_REQUESTED,
    payload: data,
  };
}

export function getMatrixDriver(data) {
  return {
    type: GET_MATRIXDRIVER.GET_MATRIXDRIVER_REQUESTED,
    payload: data,
  };
}

export function getTicketDriver(data) {
  return {
    type: GET_TICKETDRIVER.GET_TICKETDRIVER_REQUESTED,
    payload: data,
  };
}

export function getMoreDriver(data) {
  return {
    type: GET_MOREDRIVER.GET_MOREDRIVER_REQUESTED,
    payload: data,
  };
}